import "../Home/Home.css";
import Cover from "../../components/Cover/Cover";
import coverImage from "../../assets/images/mainCoverImage.webp";
import coverImageMobile from "../../assets/images/mainCoverImageMobile.webp";
import HomeAbout from "./HomeAbout/HomeAbout";
import HomeServices from "./HomeServices/HomeServices";
import HomeTrademarks from "./HomeTrademarks/HomeTrademarks";
import OurClients from "./OurClients/OurClients";
import HomeCookTogether from "./HomeCookTogether/HomeCookTogether";

const HomeRu = () => {
  const isMobile = window.innerWidth <= 1199;
  const coverImageToUse = isMobile ? coverImageMobile : coverImage;

  return <div className="page">
    <title>
    Главная | ООО «Николаевмолпром» – Pastoral и Мумуля
      </title>
      <meta
        name="description"
        content="Приветствие от ООО «Николаевмолпром»! Узнайте о продукции брендов Pastoral и Мумуля, фирменных магазинах, сертификатах качества и новинках молочной продукции."
      />
     <Cover src={coverImageToUse} text={"“Pastoral” -  Французские традиции"}/>
      <HomeAbout />
      <HomeServices />
      <HomeTrademarks />
      <OurClients />
      <HomeCookTogether />
  </div>;
};

export default HomeRu;
